export default {
    bind(el, binding) {
        const dropdownDom = el.querySelector('.el-select-dropdown__wrap')
        dropdownDom.addEventListener('scroll', function () {
            const condition = this.scrollHeight - this.scrollTop <= this.clientHeight
            if (condition) {
                binding.value && binding.value()
            }
        })
    },
}